import { skill } from '../api/entities';

export const actions = {
  listSkill: 'LIST_SKILL',
};

export function getSkills() {
  return skill.list(actions.listSkill, null, null, true);
}

const INITIAL_STATE = {
  skills: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listSkill:
      return {
        ...state,
        skills: action.body ? action.body._items : state.skills,
      };
    default:
      return {
        ...state,
      };
  }
}
